var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 80,
    viewBox: "0 0 160 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9220",
    "data-name": "Rectangle 9220",
    width: 160,
    height: 80,
    transform: "translate(0.121)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69214",
    "data-name": "Path 69214",
    d: "M299.67,240.365V264.39a2.083,2.083,0,0,0,2.109,2.056h20.184l-5.936-19.677a11.4,11.4,0,0,0-3.38-5.255h0a11.911,11.911,0,0,0-7.575-2.967l-3.4-.089a1.983,1.983,0,0,0-1.411.543A1.883,1.883,0,0,0,299.67,240.365Z",
    transform: "translate(-299.67 -238.459)",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1355",
    "data-name": "Ellipse 1355",
    cx: 12.336,
    cy: 12.026,
    rx: 12.336,
    ry: 12.026,
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69221",
    "data-name": "Path 69221",
    d: "M11.967,0A12.5,12.5,0,0,1,24.193,12.4,11.873,11.873,0,0,1,12.227,24.532,12.5,12.5,0,0,1,0,12.136,11.873,11.873,0,0,1,11.967,0Z",
    transform: "matrix(0.477, -0.879, 0.879, 0.477, 0, 21.268)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_513",
    "data-name": "Mask Group 513",
    transform: "translate(-0.121)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(9.338 7.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-242",
    transform: "translate(15.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69206",
    "data-name": "Path 69206",
    d: "M197.514,232H159.327a6.946,6.946,0,0,0-4.516,1.655h0a6.685,6.685,0,0,0-1.84,2.519l-8.612,20.715a4.615,4.615,0,0,1-3.368,2.735l-10.084,2.014a12.54,12.54,0,0,0-5.24,2.384h0a12.025,12.025,0,0,0-4.444,7.253l-1.231,6.559a4.983,4.983,0,0,0,1.168,4.205h0a5.253,5.253,0,0,0,3.958,1.767h11.592l9.1,5.4h44.721l24.672-3.472,5.4-.386a3.789,3.789,0,0,0,3.059-1.9,9.718,9.718,0,0,0,1.3-4.279,19.4,19.4,0,0,0-2.505-9.9c-1.714-3.214-4.223-3.6-7.519-14.275s-4.761-15.541-8.058-19.14S197.514,232,197.514,232Z",
    transform: "translate(-118.627 -232)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69207",
    "data-name": "Path 69207",
    d: "M186.67,312.67v21.606a2.865,2.865,0,0,0,2.9,2.828H224.4a3.871,3.871,0,0,0,2.861-1.253h0a3.675,3.675,0,0,0,.97-2.481V313.692",
    transform: "translate(-158.967 -281.546)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1586",
    "data-name": "Line 1586",
    x2: 83.506,
    transform: "translate(12.993 34.145)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69208",
    "data-name": "Path 69208",
    d: "M279.68,322.213h-4.219a.782.782,0,0,1-.791-.772h0a.782.782,0,0,1,.791-.772h4.219a.782.782,0,0,1,.791.772h0A.782.782,0,0,1,279.68,322.213Z",
    transform: "translate(-212.139 -286.46)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69209",
    "data-name": "Path 69209",
    d: "M203.935,237h-1.266a10.229,10.229,0,0,0-9.621,6.578l-7.409,19.955a1.383,1.383,0,0,0,.177,1.29,1.46,1.46,0,0,0,1.184.6h37.514a2.538,2.538,0,0,0,1.773-.717,2.411,2.411,0,0,0,.732-1.729V240.152a3.109,3.109,0,0,0-.945-2.229,3.272,3.272,0,0,0-2.285-.923Z",
    transform: "translate(-158.292 -235.071)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69210",
    "data-name": "Path 69210",
    d: "M203.935,237h-1.266a10.229,10.229,0,0,0-9.621,6.578l-7.409,19.955a1.383,1.383,0,0,0,.177,1.29,1.46,1.46,0,0,0,1.184.6h37.514a2.538,2.538,0,0,0,1.773-.717,2.411,2.411,0,0,0,.732-1.729V240.152a3.109,3.109,0,0,0-.945-2.229,3.272,3.272,0,0,0-2.285-.923Z",
    transform: "translate(-158.292 -235.071)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69211",
    "data-name": "Path 69211",
    d: "M299.67,240.365V264.39a2.083,2.083,0,0,0,2.109,2.056h20.184l-5.936-19.677a11.4,11.4,0,0,0-3.38-5.255h0a11.911,11.911,0,0,0-7.575-2.967l-3.4-.089a1.983,1.983,0,0,0-1.411.543A1.883,1.883,0,0,0,299.67,240.365Z",
    transform: "translate(-227.245 -235.967)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57138",
    "data-name": "Group 57138",
    transform: "translate(72.425 2.492)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69212",
    "data-name": "Path 69212",
    d: "M317.453,261.62l-15.743,18.6a2.143,2.143,0,0,0,1.3.448h7.361l9.55-10.861Z",
    transform: "translate(-300.903 -252.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69213",
    "data-name": "Path 69213",
    d: "M342.572,296.3l-1.255-4.163-5.988,7.277h4.421Z",
    transform: "translate(-321.217 -271.429)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69215",
    "data-name": "Path 69215",
    d: "M299.67,240.365V264.39a2.083,2.083,0,0,0,2.109,2.056h20.184l-5.936-19.677a11.4,11.4,0,0,0-3.38-5.255h0a11.911,11.911,0,0,0-7.575-2.967l-3.4-.089a1.983,1.983,0,0,0-1.411.543A1.883,1.883,0,0,0,299.67,240.365Z",
    transform: "translate(-227.245 -235.967)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69216",
    "data-name": "Path 69216",
    d: "M118.035,350.85s-1.365.957-1.365,2.114.792,2.7,1.583,2.959.95-.868.95-.868A17.262,17.262,0,0,1,118.035,350.85Z",
    transform: "translate(-116.67 -304.996)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69217",
    "data-name": "Path 69217",
    d: "M1.508,0,2,0A1.437,1.437,0,0,1,3.46,1.429L3.428,8.084A1.47,1.47,0,0,1,1.951,9.527l-.488,0A1.437,1.437,0,0,1,0,8.1L.031,1.445A1.47,1.47,0,0,1,1.508,0Z",
    transform: "translate(1.891 33.991) rotate(10.71)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9219",
    "data-name": "Rectangle 9219",
    width: 4.619,
    height: 8.746,
    rx: 2.309,
    transform: "translate(103.555 39.739)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1354",
    "data-name": "Ellipse 1354",
    cx: 12.336,
    cy: 12.026,
    rx: 12.336,
    ry: 12.026,
    transform: "translate(2.766 41.796)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57139",
    "data-name": "Group 57139",
    transform: "translate(2.766 41.796)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69218",
    "data-name": "Path 69218",
    d: "M142.322,332l.526,15.24L135,334.7Zm9.3,27.185-8.77-11.96,1.674,15.163Z",
    transform: "translate(-130.512 -335.214)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1356",
    "data-name": "Ellipse 1356",
    cx: 12.336,
    cy: 12.026,
    rx: 12.336,
    ry: 12.026,
    transform: "translate(2.766 41.796)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1357",
    "data-name": "Ellipse 1357",
    cx: 8.113,
    cy: 7.909,
    rx: 8.113,
    ry: 7.909,
    transform: "translate(6.989 45.912)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1358",
    "data-name": "Ellipse 1358",
    cx: 5.869,
    cy: 5.722,
    rx: 5.869,
    ry: 5.722,
    transform: "translate(9.233 48.1)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69219",
    "data-name": "Path 69219",
    d: "M11.967,0A12.5,12.5,0,0,1,24.193,12.4,11.873,11.873,0,0,1,12.227,24.532,12.5,12.5,0,0,1,0,12.136,11.873,11.873,0,0,1,11.967,0Z",
    transform: "matrix(0.477, -0.879, 0.879, 0.477, 68.211, 58.624)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57140",
    "data-name": "Group 57140",
    transform: "translate(68.211 37.356)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69220",
    "data-name": "Path 69220",
    d: "M323.731,348.724l-14.738,5.112,9.894-11.1Zm-23.746,16.883L309,353.836l-14.311,6.15Z",
    transform: "translate(-292.448 -337.371)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69222",
    "data-name": "Path 69222",
    d: "M11.967,0A12.5,12.5,0,0,1,24.193,12.4,11.873,11.873,0,0,1,12.227,24.532,12.5,12.5,0,0,1,0,12.136,11.873,11.873,0,0,1,11.967,0Z",
    transform: "matrix(0.477, -0.879, 0.879, 0.477, 68.211, 58.624)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69223",
    "data-name": "Path 69223",
    d: "M7.868,0a8.2,8.2,0,0,1,8.023,8.155,7.826,7.826,0,0,1-7.868,8A8.2,8.2,0,0,1,0,8,7.826,7.826,0,0,1,7.868,0Z",
    transform: "matrix(0.421, -0.907, 0.907, 0.421, 74.083, 57.621)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69224",
    "data-name": "Path 69224",
    d: "M5.819,0a5.892,5.892,0,0,1,5.9,5.772A5.7,5.7,0,0,1,5.9,11.466,5.892,5.892,0,0,1,0,5.694,5.7,5.7,0,0,1,5.819,0Z",
    transform: "matrix(0.961, -0.276, 0.276, 0.961, 77.548, 49.92)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69225",
    "data-name": "Path 69225",
    d: "M185.3,299.294c.954,2.056,1.187,3.97.483,4.275s-2.022-1.119-2.976-3.175-1.187-3.974-.483-4.279S184.344,297.233,185.3,299.294Z",
    transform: "translate(-156.094 -271.353)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-122",
    transform: "translate(0 65.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_254",
    "data-name": "Line 254",
    d: "M140,.5H0v-1H140Z",
    transform: "translate(0 0.5)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/carIcon.84df359bc17ddaf02ea98977c13c7f4d.svg";
export { ForwardRef as ReactComponent };